import { FileQuestion, ShieldOff } from 'lucide-react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/common/empty-state';

export function ForbiddenPage() {
  return (
    <EmptyState
      icon={ShieldOff}
      title="You don't have access to this"
      description="If you think this is a mistake, ask your HR administrator to review your permissions."
      action={
        <Button asChild variant="outline">
          <Link to="/">Back to dashboard</Link>
        </Button>
      }
      className="mt-10"
    />
  );
}

export function NotFoundPage() {
  return (
    <EmptyState
      icon={FileQuestion}
      title="Page not found"
      description="The page you're looking for doesn't exist or has moved."
      action={
        <Button asChild variant="outline">
          <Link to="/">Back to dashboard</Link>
        </Button>
      }
      className="mt-10"
    />
  );
}
